import {call, all, put, select, takeEvery} from "redux-saga/effects"

import api from "../../services/ApiService"
import {
  UserProfileCreators as Creators,
  UserProfileTypes as Types
} from "./redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {i18n, readableErrors} from "../../utils"

export default function* router(dispatch, {payload}) {
  // listen for profile request action
  yield takeEvery(Types.USER_PROFILE_REQUEST, fetchUserData, dispatch)

  // tracking
  yield put(
    AppCreators.trackingAdd({
      event: "mtm.virtualPageView",
      section: "profile",
      profile_action:
        typeof payload.params.action !== "undefined"
          ? payload.params.action
          : "profile",
      document_title: i18n.t("Mein Profil")
    })
  )

  // trigger profile request action
  yield put(Creators.request(payload.params.slug))
}

export function* fetchUserData(_dispatch, _action) {
  let state = yield select()
  const lang = state.router.params.lang

  try {
    const [
      userDataResponse,
      userProgressResponse,
      userBookmarksResponse,
      userCertificatesResponse,
      {completed_modules: completedModules},
      numBookmarksResponse
    ] = yield all([
      call(api.getUserProfile),
      call(api.getUserProgress),
      call(api.getBookmarks, lang),
      call(api.getUserCertificates, lang),
      call(api.getUserModuleCertificates, lang),
      call(api.getBookmarksNumber, lang)
    ])

    yield put(
      Creators.success(
        userDataResponse,
        userProgressResponse,
        userBookmarksResponse,
        userCertificatesResponse,
        completedModules,
        numBookmarksResponse
      )
    )

    state = yield select()
    let langurl
    lang === "de"
      ? (langurl = state.router.pathname.replace("/de/", "/en/"))
      : (langurl = state.router.pathname.replace("/en/", "/de/"))
    yield put(LangCreators.success(langurl))
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserProfile/sagas.js